import React from 'react';
import { SkeletonTheme } from 'react-loading-skeleton';

import { useSelector } from 'react-redux';

import { ThemeProvider as ThemeProviderBase } from 'styled-components';

import light from './styles/themes/lightMode';
import dark from './styles/themes/darkMode';

export default function ThemeProvider({ children }) {
  const isDarkTheme = useSelector(state => state.usuario.isDarkTheme);
  const theme = isDarkTheme ? dark : light;
  return (
    <ThemeProviderBase theme={theme}>
      <SkeletonTheme
        color={theme.skeleton.color}
        highlightColor={theme.skeleton.highlight}
      >
        {children}
      </SkeletonTheme>
    </ThemeProviderBase>
  );
}

